import { PersonalDataState } from './index';
import { IStore } from '@store/index';
import { GetterTree } from 'vuex';
import ContactPerson from "@store/checkout/interfaces/contactPerson";
import { filterObject } from "@store/helper/object";
import { PpsCustomerData } from "@store/checkout/interfaces/ppsPayload";

export default {
    hasMainDriver: (state) => (rIndex: number, pIndex: number) => {
        return state.rooms[rIndex].mainDriver !== null && state.rooms[rIndex].mainDriver !== pIndex
    },
    isContactInfoUsed: (state) => (pIndex: number) => {
        return state.useContactInfo !== null && state.useContactInfo !== pIndex
    },
    personsPerRoom: (state) => (roomId: string, roomNumber: number) => {
        return state.persons.filter(person => person.roomId === roomId && person.roomNumber === roomNumber)
    },
    filledPersonForm: (_) => (person: ContactPerson) => {
        const filledEntries = filterObject(
            person,
            ([key, value]) => value !== "" && key !== 'isDriver' && key !== 'roomNumber' && key !== 'roomId');

        return Object.keys(filledEntries).length;
    },
    filledContactInfo: (state) => {
        const filledEntries = filterObject(state.contactInfo, ([_, value]) => value !== "");

        return Object.keys(filledEntries).length;
    },
    getContactIso2 (state): string {
        return state.contactInfo.iso2;
    },
    getContactDetails: (state): PpsCustomerData => {
        return {
            customerName: state.contactInfo.firstname + ' ' + state.contactInfo.lastname,
            customerEmail: state.contactInfo.email,
            customerAddress: state.contactInfo.street,
            customerTown: state.contactInfo.city,
            customerCountryCode: state.contactInfo.iso2,
            customerPostcode: state.contactInfo.zip
        }
    }
} as GetterTree<PersonalDataState, IStore>
